<template>
  <div class="backgournd-box">
    <b-container id="analyze">
      <b-row>
        <b-col class="m-landing-h1-center">
          <h1 class="m-landing-h1">Analyze your customer data</h1>
          <p class="m-landing-h1-brief">We offer a series of reports, starting at just $200. Upload your customer file
            and choose a target area. Turnaround time varies from one to five business days.</p>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <h3 class="m-landing-h3">Choose a report</h3>
          <p>We offer a series of reports, starting at just $200. Upload your customer file and choose a target area. Turnaround time varies from one to five business days.</p>
          <div class="analyze-btn">
            <b-btn
                   variant="primary"
                   :href="$store.getters['config/link']('portaitreports')"
                   v-m-ua-event="['landing', 'dataservice', 'Analyze your customers']">Get Started & View Samples </b-btn>
            <b-btn>Ask an expert</b-btn>
          </div>
        </b-col>
        <b-col style="text-align: center">
          <b-img src="./static/img/portraitReportsWhite.png"/>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <h3 class="m-landing-h3">View sample reports</h3>
          <p>Learn about each report before you begin.</p>
          <div class="service-box">
            <a v-for="menu in menus" class="menu-box"
               :href="$store.getters['config/link'](menu.link)"
               v-m-ua-event="['landing', 'analyzeReport', menu.title]">
              <h3 class="service-btn">
                {{menu.title}}
              </h3>
              <!--<b-btn>Get Started</b-btn>-->
              <div class="menu-content-box">
                <p>{{menu.benefit}}</p>
              </div>
            </a>
          </div>
        </b-col>
      </b-row>

    </b-container>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        menus: [
          {
            title: 'look-Alike Report',
            benefit: 'This report includes a demographic portrait of your file plus a calculated Market Penetration Index ("MPI") which enables you to define the prospective market potential. The higher the index calculation, the greater success you had.',
            link: 'reportLookALike'
          },
          {
            title: 'Enhanced Look-Alike Report',
            benefit: 'This report helps you take a broad view of your customer base, identify where you have a strong or weak market presence, learn who your best customers are and how they are different from the rest, and more!',
            link: 'reportEnhanceLookAlike'
          },
          {
            title: 'PersonicX Portrait Report',
            benefit: 'This report enables you to better understand who your best customers are using segmentation. It includes an index that enables you to define the prospective market potential.',
            link: 'reportPortrait'
          },
          {
            title: 'Data Portrait Analysis',
            benefit: 'This report compares the demographic and lifestyle/interest characteristics of customer households to the characteristics of households in your local or regional geographic area.',
            link: 'reportPortraitRegional'
          }
        ]
      }
    }
  }
</script>

<style scoped lang="scss">
  .backgournd-box {
    margin-top: 16px;
    padding-top: 32px;
    padding-bottom: 64px;
    min-height: 280px;
    background-color: $color-background;
  }
  .order-btn {
    width: 150px;
    margin-bottom: 10px;
    display: block;
    text-align: center;
    padding-left: 0;
    padding-right: 0;
    margin-right: 24px;
  }
  .menu-head-box {
    background-color: $color-primary;
    height: 108px;
    padding: 16px;
    border-radius: 8px 8px 0 0;
  }
  .menu-head-box h4 {
    color: #fff
  }
  .menu-content-box {
    padding: 16px;
    height: 164px
  }

  .analyze-btn {
    margin-top: 32px;
    display: block;
  }

  .service-box {
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: stretch;
  }

  .menu-head-box {
    background-color: $color-primary;
    height: 108px;
    padding: 16px;
  }
  .menu-head-box h4 {
    color: #fff
  }
  .menu-content-box {
    padding: 0 0;
    height: 80px;
    text-align: left;
    margin-left: 40px;
  }

  .menu-box {
    width: calc(25% - 32px);
    margin-right: 16px;
    margin-left: 16px;
    cursor: pointer;
    border-radius: 8px;
    text-align: center;
    padding: 16px;
    padding-top: 32px;
    height: 320px;
    display: block;
  }
  .menu-box:hover {
    text-decoration: none;
  }

  .menu-box:hover {
    transform: scale(1.1);
    background-color: $color-second;
  }
</style>



// WEBPACK FOOTER //
// src/components/landings/MSectionAnalyze.vue